import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../services/api";

// Petit bouton "+ playlist" : charge les playlists de l'utilisateur au clic,
// permet d'en choisir une (ou d'en créer une) et y ajoute la station.
export default function AddToPlaylistButton({ station }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const openMenu = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    setLoading(true);
    try {
      const res = await api.get("/api/playlists");
      setPlaylists(res.data);
    } catch {
      setMsg(t("addToPlaylist.loadError"));
    } finally {
      setLoading(false);
    }
  };

  const addTo = async (playlistId) => {
    try {
      await api.post(`/api/playlists/${playlistId}/items`, {
        station_uuid: station.station_uuid,
        name: station.name,
        url: station.url,
        favicon: station.favicon,
        country: station.country,
      });
      setMsg(t("addToPlaylist.added"));
      setTimeout(() => { setOpen(false); setMsg(""); }, 1000);
    } catch {
      setMsg(t("addToPlaylist.error"));
    }
  };

  const createAndAdd = async () => {
    const name = window.prompt(t("addToPlaylist.promptName"));
    if (!name) return;
    try {
      const res = await api.post("/api/playlists", { name });
      await addTo(res.data.id);
    } catch {
      setMsg(t("addToPlaylist.error"));
    }
  };

  return (
    <div className="relative">
      <button
        onClick={openMenu}
        title={t("addToPlaylist.title")}
        className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center"
      >
        ＋
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-20 p-2 text-sm">
          {loading && <div className="px-2 py-1 text-gray-500">{t("common.loading")}</div>}
          {!loading && playlists.length === 0 && (
            <div className="px-2 py-1 text-gray-500">{t("addToPlaylist.empty")}</div>
          )}
          {!loading &&
            playlists.map((p) => (
              <button
                key={p.id}
                onClick={() => addTo(p.id)}
                className="block w-full text-left px-2 py-1.5 rounded hover:bg-purple-50"
              >
                {p.name} <span className="text-gray-400">({p.items_count})</span>
              </button>
            ))}
          <button
            onClick={createAndAdd}
            className="block w-full text-left px-2 py-1.5 rounded hover:bg-purple-50 text-purple-600 font-medium border-t mt-1 pt-2"
          >
            {t("addToPlaylist.new")}
          </button>
          {msg && <div className="px-2 py-1 text-xs text-green-600">{msg}</div>}
        </div>
      )}
    </div>
  );
}
